/* association inventory reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

const defaultSubgroup = '#DEFAULT#';

export interface IViewFiltersAssociationInventoryState {
    subgroup: string;
    gridSelectedKeys: any;
}

const initialState: IViewFiltersAssociationInventoryState = {
    subgroup: defaultSubgroup,
    gridSelectedKeys: [],
};

export function viewFiltersAssociationInventoryReducer(state: IViewFiltersAssociationInventoryState = initialState, action: any): IViewFiltersAssociationInventoryState {
    switch (action.type) {
        case Actions.VIEW_ASSOCIATION_INVENTORY_SUBGROUP:
            return _.merge({}, state, { subgroup: action.subgroup });
        case Actions.ASSOCIATION_INVENTORY_GRID_SELECT:
            return _.merge({}, state, { gridSelectedKeys: _.cloneDeep(action.keys) });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/viewFiltersAssociationInventoryReducer.tsx